export const DEFAULT_PAYMENT_TERMS_DAYS = 14;

export function isPaymentTermsDays(value: unknown): value is number {
  return typeof value === 'number' && Number.isInteger(value) && value >= 0 && value <= 365;
}
